import { IconName, Icon } from '@blueprintjs/core';
import { UnstyledButton } from '@mantine/core';
import styled from 'styled-components';
import Text from '@components/Text/Text';

interface MenuItemProps {
  title: string;
  icon: IconName;
  onClick?: VoidFunction;
  className?: string;
  tooltipId?: string;
  tooltipText?: string;
  disabled?: boolean;
}
function MenuItem(props: MenuItemProps) {
  const { title, icon, onClick, tooltipId, tooltipText, disabled, ...rest } =
    props;

  // Todo: turn these toggle-able as disabled.

  return (
    <UnstyledButton
      {...rest}
      data-for={tooltipId}
      data-tip={tooltipText}
      onClick={onClick}
      data-disabled={disabled}
    >
      <Icon icon={icon} />
      <Text text="p200" textColor={disabled ? 'n500' : 'n800'}>
        {title}
      </Text>
    </UnstyledButton>
  );
}

export default styled(MenuItem)`
  && {
    display: flex;
    width: 100%;
    align-items: center;
    padding: 12px 0px 12px 8px;
    column-gap: 10px;
    color: var(--beam-color-neutral-n600);

    &[data-disabled='true'] {
      cursor: default;
      color: var(--beam-color-neutral-n500);
    }
  }
`;
